import { render, staticRenderFns } from "./financialRatios.vue?vue&type=template&id=0ca4599e&scoped=true"
import script from "./financialRatios.vue?vue&type=script&lang=js"
export * from "./financialRatios.vue?vue&type=script&lang=js"
import style0 from "./financialRatios.vue?vue&type=style&index=0&id=0ca4599e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4599e",
  null
  
)

export default component.exports